module.exports = __webpack_public_path__ + "img/1024.444b0668.svg";